import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { JSONStringify, ParseQueryType } from 'zigra-ng-framework';
import {
    GraphQLResponse,
    InvoiceType,
    InvoiceTypeQuery,
    ProviderSignatureType,
    ProviderSignatureTypeQuery
} from '../zigra-schema.autogenerated.models';

@Injectable()
export class AuthorizeOrganizationsSchema {
    //private schemaEndPoint = 'https://localhost:7043/graphql/Authorized/Solutions';
    protected entityName: string = 'Authorization';
    protected schemaEndPoint = `${environment.graphQLEndPoint}/Authorization`;

    constructor(protected http: HttpClient) {}

    public ApplyForRegistration(
        organizationName: string,
        Email: string,
        VATNumber: string,
        UserName: string,
        Pin: string
    ) {
        debugger;
        //OrganizationName: "Test", Email: "test4@email.test.GR  ", VATNumber: "800819299-04  ", UserName: "test4@email.test.Gr", Pin: "123456  "
        const sQuery = `mutation ApplyForRegistration {
            ApplyForRegistration(OrganizationName: "${organizationName ?? null}", Email: "${Email ?? null}", VATNumber: "${VATNumber ?? null}", UserName: "${UserName ?? null}", Pin: "${Pin ?? null}" ) 
             { 
                _id
                Name
                EMail    
                TAXId
                ApplicationDate
                ApprovalDate,
                Expiration
            }  
        }`;

        return this.http.post<
            | GraphQLResponse<{
                  ApplyForRegistration: any | undefined;
              }>
            | undefined
        >(this.schemaEndPoint, {
            query: sQuery
        });
    }

    public VerifyRegistrationEMail(
        Email: string,
        VATNumber: string,
        VerificationCode: string
    ) {
        debugger;
        //OrganizationName: "Test", Email: "test4@email.test.GR  ", VATNumber: "800819299-04  ", UserName: "test4@email.test.Gr", Pin: "123456  "
        const sQuery = `mutation VerifyRegistrationEMail {
            VerifyRegistrationEMail(Email: "${Email ?? null}", VATNumber: "${VATNumber ?? null}", VerificationCode: "${VerificationCode ?? null}") 
             { 
                _id
                Name
                EMail    
                TAXId
                ApplicationDate
                ApprovalDate,
                Expiration
            }  
        }`;

        return this.http.post<
            | GraphQLResponse<{
                  VerifyRegistrationEMail: any | undefined;
              }>
            | undefined
        >(this.schemaEndPoint, {
            query: sQuery
        });
    }
}
